import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { 
  Container, 
  Grid,
  useTheme,
  CircularProgress,
  Box
} from '@mui/material';
import {
  Business as CompanyIcon,
  DateRange as SeasonIcon,
  AssignmentOutlined as ThemeIcon,
  RecordVoiceOver as ClientIcon,
  AppRegistration as EntryIcon,
  GroupWork as TeamIcon,
  People as TeamMemberIcon,
  PersonOutline as UserIcon,
  Place as PlaceIcon
} from '@mui/icons-material';

// 共通コンポーネントのインポート
import { PageHeader, ActionCard } from '../components/common';

export const AdminTop = () => {
    const navigate = useNavigate();
    const { instance } = useMsal();
    const theme = useTheme();
    const [userName, setUserName] = useState('');
    const [loading, setLoading] = useState(true);

    const handleButtonClick = (managementType) => {
        navigate(`/masterDataManagement?type=${managementType}`);
    };

    const handleUserEditClick = () => {
        navigate(`/userManagement`);
    }

    // 初期処理時に実行
    useEffect(() => {
        setLoading(true);
        let activeAccount;

        if (instance) {
            activeAccount = instance.getActiveAccount();
            console.log(activeAccount.idTokenClaims.extension_PermissionType);
            if (activeAccount.idTokenClaims.extension_PermissionType === 1) {
                navigate(`/error`);
            }
            // ユーザー名を設定
            setUserName(activeAccount.name || activeAccount.username || 'システム管理者');
        }
        setLoading(false);
    }, [instance, navigate]);

    // 管理メニュー項目の定義
    const menuItems = [
        {
            icon: <CompanyIcon />,
            title: '会社管理',
            description: '企業情報の登録・編集・削除を行います',
            onClick: () => handleButtonClick('company'),
            color: theme.palette.primary.main
        },
        {
            icon: <SeasonIcon />,
            title: '期管理',
            description: 'プログラム期間の設定と管理を行います',
            onClick: () => handleButtonClick('season'),
            color: theme.palette.secondary.main
        },
        {
            
            icon: <PlaceIcon />, // Updated icon to PlaceIcon
            title: '開催場所管理',
            description: 'プログラムの開催場所を作成・編集します',
            onClick: () => handleButtonClick('venue'),
            color: '#4caf50' // Updated color to green
        },
        {
            icon: <ThemeIcon />,
            title: 'テーマ管理',
            description: 'プログラムのテーマを作成・編集します',
            onClick: () => handleButtonClick('theme'),
            color: '#3f51b5'
        },
        {
            icon: <ClientIcon />,
            title: '答申先管理',
            description: 'テーマの答申先情報を管理します',
            onClick: () => handleButtonClick('client'),
            color: '#009688'
        },
        {
            icon: <EntryIcon />,
            title: 'エントリー枠管理',
            description: '企業ごとのエントリー枠を設定します',
            onClick: () => handleButtonClick('entry'),
            color: '#ff5722'
        },
        {
            icon: <TeamIcon />,
            title: 'チーム管理',
            description: 'チームの作成・編集・削除を行います',
            onClick: () => handleButtonClick('team'),
            color: '#9c27b0'
        },
        {
            icon: <TeamMemberIcon />,
            title: 'チームメンバー管理',
            description: 'チームメンバーの割り当てと管理を行います',
            onClick: () => handleButtonClick('teamMember'),
            color: '#2196f3'
        },
        {
            icon: <UserIcon />,
            title: 'ユーザー管理',
            description: 'システム利用者の登録と権限管理を行います',
            onClick: () => handleUserEditClick(),
            color: '#673ab7'
        }
    ];

    // ローディング表示
    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Container maxWidth="lg" sx={{ pt: 4, pb: 8 }}>
            <PageHeader 
              title="システム管理者ダッシュボード" 
              subtitle={`ようこそ、${userName}さん`} 
            />

            <Grid container spacing={3}>
                {menuItems.map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <ActionCard {...item} />
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default AdminTop;